import React from 'react';

const NotFound = () => {
    return <div className="lead text-center py-5 my-5">
        <div>
            <strong className="fs-1">404</strong>
        </div>
        <div>
            <i class="bi bi-sticky"></i> Stránka nenalezena
        </div>
    </div>
};

export default NotFound;
